
export const ConfirmationModal = ({ visible = false, isSubmitting, continueHandler, onClose }) => {
    return visible ? (
        <div className="absolute top-0 left-0 z-10 h-full w-full bg-[#0001] before:absolute before:top-0 before:left-0 before:h-full before:w-full before:backdrop-blur-md">
            <div className="absolute top-1/2 left-1/2 w-5/6 -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white px-6 py-8 lg:w-2/5">
                <p className="text-[20px] sm:text-[24px] font-medium color-black capitalize mb-2">submit question</p>
                <p className="text-[14px] color-black">Are you sure you want to continue?</p>
                <div className="flex items-center justify-between mt-8">
                    <button
                        className={`capitalize text-[16px] font-[500] tracking-[0.2px] text-[rgba(0,0,0,0.5)]`}
                        onClick={onClose}
                    >
                        cancel
                    </button>
                    <button
                        disabled={isSubmitting}
                        className={`capitalize text-[16px] font-[500] tracking-[0.2px] text-[#FF7A1A] ${isSubmitting ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
                        onClick={continueHandler}
                    >
                        continue
                    </button>
                </div>
            </div>
        </div>
    ) : (<></>)
}